import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const operationsApi = {
  getOperationalProfiles: (equipmentId) => {
    const params = equipmentId ? { equipment_id: equipmentId } : {};
    return axios.get(`${API}/operations/profiles`, { params });
  },

  createOperationalProfile: (data) =>
    axios.post(`${API}/operations/profiles`, data),

  updateOperationalProfile: (profileId, data) =>
    axios.put(`${API}/operations/profiles/${profileId}`, data),

  deleteOperationalProfile: (profileId) =>
    axios.delete(`${API}/operations/profiles/${profileId}`),

  analyzeOperations: (data) =>
    axios.post(`${API}/operations/analyze`, data),

  getFuelAuditProfiles: (equipmentId) => {
    const params = equipmentId ? { equipment_id: equipmentId } : {};
    return axios.get(`${API}/operations/profiles`, { params });
  },

  createFuelAuditProfile: (data) =>
    axios.post(`${API}/operations/profiles`, data),

  updateFuelAuditProfile: (profileId, data) =>
    axios.put(`${API}/operations/profiles/${profileId}`, data),

  deleteFuelAuditProfile: (profileId) =>
    axios.delete(`${API}/operations/profiles/${profileId}`),

  analyzeFuelAudit: (data) =>
    axios.post(`${API}/operations/analyze`, data),

  getEquipments: () =>
    axios.get(`${API}/equipments`),
};

export default operationsApi;
